import { MapIcon } from "@/Icons/v2/Map";
import { TableIcon } from "@/Icons/v2/Table";
import { useTrans } from "@/translations";

import { ViewMode } from "../types";

const BUTTONS = [
  {
    key: ViewMode.TABLE,
    icon: <TableIcon />,
    label: "portfolioPage:buildingListTableView",
  },
  {
    key: ViewMode.MAP,
    icon: <MapIcon />,
    label: "portfolioPage:buildingListMapView",
  },
];

type Props = {
  viewMode: ViewMode;
  setViewMode: (value: ViewMode) => void;
};

export const ViewModeSelect: React.FC<Props> = ({ viewMode, setViewMode }) => {
  const { t } = useTrans();

  return (
    <div className="bg-grey1 border-grey2 inline-flex gap-[4px] rounded-lg border p-[3px]">
      {BUTTONS.map((button) => (
        <button
          key={button.key}
          onClick={() => setViewMode(button.key)}
          className={`inline-flex cursor-pointer items-center gap-[6px] rounded-md px-[11px] py-[5px] text-[12px] whitespace-nowrap transition-colors ${
            viewMode === button.key
              ? "bg-black font-semibold text-white"
              : "text-grey6 font-medium"
          }`}
        >
          {button.icon}
          {t(button.label)}
        </button>
      ))}
    </div>
  );
};
